"use client";

import { PAGES } from "@idss/libraries";
import { ActionIcon, NavLink, NavLinkProps } from "@mantine/core";
import { toString } from "lodash";
import { usePathname } from "next/navigation";

import Link, { LinkProps } from "next/link";

interface ButtonProps extends NavLinkProps, LinkProps {
  opened?: boolean;
}

export function AppShellButton({ opened, ...props }: ButtonProps) {
  const pathname = usePathname();

  const isActive =
    props.href === PAGES.DASHBOARD
      ? pathname === PAGES.DASHBOARD
      : pathname.startsWith(toString(props.href));

  return opened ? (
    <NavLink
      active={isActive}
      variant="pro-staff-app-shell"
      component={Link}
      {...props}
    />
  ) : (
    <ActionIcon
      c="inherit"
      variant="app-shell"
      data-active={isActive}
      size={48}
    >
      {props.leftSection}
    </ActionIcon>
  );
}
